<template>
  <li :class="['list--item', isFourthVersion ? 'fourth-version' : 'third-version']">
    <b-button
      :id="`left-navigation-${getItemId}`"
      :class="[
        'item--wrapper',
        !hideChildren && isTable && !custom && 'table--item',
        !hideChildren && isFolder && !custom && 'folder',
        !hideChildren && isItemSelected ? 'selected--item' : '',
        !hideChildren && isSubModule && 'folder',
      ]"
      variant="outlined"
      squared
      @click="onLinkClick"
    >
      <b-tooltip
        v-if="isTooltipVisible"
        :title="item.label"
        triggers="hover"
        placement="right"
        boundary=".menu"
        :target="getFormattedMenuItemText"
      />
      <div class="item--wrapper__content">
        <font-awesome-icon
          class="item--wrapper__content-icon"
          :icon="item.icon"
        />
        <b-link
          v-if="item.path"
          :id="getFormattedMenuItemText"
          :to="item.path"
          class="item_label"
        >
          <span v-html="formattedItemName" />
        </b-link>
        <span
          v-else
          v-html="formattedItemName"
        />
      </div>
      <b-button
        v-if="!hideChildren && isChildrenExists && !isLoanCalculatorModule"
        variant="outline"
        size="sm"
        @click.stop="toggleOpen"
      >
        <font-awesome-icon
          :size="isFourthVersion ? 'xl' : 'sm'"
          :icon="isFourthVersion ? 'caret-right' : 'chevron-right'"
          :class="['chevron', isOpen && 'opened']"
        />
      </b-button>
      <b-button
        v-if="isEditIconVisible(item)"
        variant="outline"
        size="sm"
        @click.stop="onEditIconClick"
      >
        <font-awesome-icon
          icon="edit"
          class="edit-icon"
        />
      </b-button>
    </b-button>
    <div

      v-if="!hideChildren && isChildrenExists && isOpen && !isLoanCalculatorModule"
      :class="['content', isOpen ? 'show' : 'hide']"
    >
      <sidebar-item
        v-for="(subItem, index) of item.children"
        :key="index"
        :item="subItem"
        :is-search-value-exist="isSearchValueExist"
        :search-value="searchValue"
      />
    </div>
  </li>
</template>

<script>
import SidebarItemContent from './SidebarItemContent';
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('app');
const {
  mapState: sidebarMapState,
  mapActions: sidebarMapActions,
} = createNamespacedHelpers('sidebar');

export default {
  name: 'SidebarItem',
  components: {
    SidebarItemContent,
  },
  props: {
    item: Object,
    isSearchValueExist: Boolean,
    searchValue: String,
    hideChildren: Boolean,
    custom: Boolean,
  },
  data() {
    return {
      isOpen: false,
      isSelected: false,
      container: null,
      isTooltipVisible: false,
    };
  },
  watch: {
    isSearchValueExist(val) {
      if (val) {
        this.isOpen = this.item.isOpen;
        this.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    },
    item: {
      handler() {
        this.itemWatchHandler();
      },
      deep: true,
      immediate: true,
    },
    selectedFolderGuid:{
      handler(){
        if(this.item.isSystem && !this.item.path) return;
        this.itemWatchHandler();
      },
    },
    selectedTable:{
      handler(){
        this.itemWatchHandler();
      },
    },
  },
  computed: {
    ...mapState(['menuCollapsed', 'isFourthVersion']),
    ...sidebarMapState({
      selectedTable: state => state.selectedTable,
      selectedModule: state => state.selectedModule,
      selectedFolderGuid: state => state.selectedFolder,
    }),
    formattedItemName() {
      return this.searchValue
        ? this.item.label.replace(
          new RegExp(`(${this.searchValue})`, 'i'),
          '<span style="color:#ff1a09;">$1</span>',
        )
        : this.item.label;
    },
    isPowerBiReportEntity() {
      return  JSON.parse(this.item.entityConfig).EntityType === 'powerBiReport';
    },
    isPowerAppEntity() {
      return  JSON.parse(this.item.entityConfig).EntityType === 'powerApp';
    },
    isLoanCalculatorModule() {
      return this.item.label === 'Loan Calculator';
    },
    getItemId() {
      return this.item.label.split(' ').join('_');
    },
    isChildrenExists() {
      return 'children' in this.item ? !!this.item.children.length : false;
    },
    getFormattedMenuItemText() {
      return (this.item.label || '').toString().replaceAll(' ', '_');
    },
    isItemSelected() {
      const moduleUuid = this.$route.params.moduleUuid || this.$route.query.module_uuid;
      const isAdministration = this.$route.path.includes('administration');
      const isMonitoring = this.$route.path.includes('monitoring');
      const isModuleConfiguration = !moduleUuid;
      const isFileManipulation = this.$route.path.includes('file-manipulation');
      const isTheSameModule = this.item.moduleGuid === moduleUuid;

      if (isModuleConfiguration) {
        return this.item.label === 'Module Configuration';
      }
      if (isMonitoring) {
        return this.item.label === 'Monitoring' || isTheSameModule;
      }
      if (isAdministration) {
        return this.item.label === 'Administration' || isTheSameModule;
      }

      if (isFileManipulation) {
        return this.item.label === 'File Manipulation' || isTheSameModule;
      }

      switch (this.item.type) {
      case 'folder':
        const folder = localStorage.getItem('folder');
        return this.item.folderGuid === this.selectedFolderGuid || this.item.folderGuid === folder;
      case 'module':
        return isTheSameModule;
      case 'table':
        const tableUuid = this.$route.params.tableId;
        return this.item.entityGuid === tableUuid
              || this.item.entityGuid === this.selectedTable
              || this.$route.path.includes(this.item.entityGuid);
      }
    },
    isSubModule() {
      return this.item.type === 'sub-module';
    },
    isFolder() {
      return this.item.type === 'folder';
    },
    isTable() {
      return this.item.type === 'table';
    },
    isModule() {
      return this.item.type === 'module';
    },
    isEditMode() {
      return this.$route.path.includes('builder');
    },
    // getRouterSeparatorByMode() {
    //   return this.$router.mode === 'hash' ? '#' : ''
    // }
  },
  methods: {
    ...mapActions(['toggleMenuHide']),
    ...sidebarMapActions([
      'setSelectedModuleAction',
      'setSelectedFolderAction',
      'setSelectedTableAction',
      'setSelectedModuleName',
    ]),
    itemWatchHandler(){        
      const moduleUuid = this.$route.params.moduleUuid || this.$route.query.module_uuid;
      if (this.isModule) {
        this.isOpen = (this.item.moduleGuid && (this.item.moduleGuid === moduleUuid)) || this.item.isOpen;
      } else if (this.isTable) {
      } else {
        this.isOpen = this.item.folderGuid === this.selectedFolderGuid || this.item.isOpen;      
      }     
    },
    onEditIconClick() {
      let res;
      if(this.isPowerAppEntity) {
        res = this.item.path.replace('power-apps-table', 'builder-power-apps');
      } else if (this.isPowerBiReportEntity) {
        res = this.item.path.replace('power-bi-report', 'builder-power-bi-report');
      } else {
        res = this.item.path.replace('table', 'builder');
      }
      this.setSelectedTableAction(this.item);
      localStorage.setItem('folder', this.item.folderGuid);
      this.$router.push(res);
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    onLinkClick() {
      switch (this.item.type) {
      case 'table':
        this.setSelectedTableAction(this.item);
        localStorage.setItem('folder', this.item.folderGuid);
        localStorage.setItem('table_rights', this.item.currentUserPermissionLevel);
        this.$router.push(this.item.path);
        break;
      case 'module':
        this.setSelectedModuleName(this.item.label);
        this.setSelectedTableAction(null);
        this.setSelectedModuleAction(this.item.moduleGuid);
        this.setSelectedFolderAction(null);
        if (this.item.label !== 'Module Configuration') {
          localStorage.removeItem('folder');
        }
        this.item.path && this.$router.push(this.item.path);
        break;
      case 'sub-module':
        this.setSelectedTableAction(null);
        this.setSelectedModuleAction(this.item.moduleGuid);
        this.setSelectedModuleName(this.item.label);
        this.setSelectedFolderAction(this.item);
        this.$router.push(this.item.path);
        break;
      case 'folder':
        localStorage.setItem('folder', this.item.folderGuid);
        this.setSelectedModuleAction(this.item.moduleGuid);
        this.setSelectedFolderAction(this.item);
        this.$router.push(this.item.path);
        break;
      }
    },
    isEditIconVisible(item) {
      return this.isEditMode && this.isTable && ['admin', 'edit'].includes(item.currentUserPermissionLevel);
    },
  },
  async mounted() {
    const $item = document.getElementById(this.getFormattedMenuItemText);
    this.isTooltipVisible = $item && ($item.scrollWidth > $item.offsetWidth);

    const item = document.getElementById(`left-navigation-${this.getItemId}`);
    this.container = document.querySelector('.menu');
    if (item.classList.contains('selected--item') && !this.isTable && !this.item.isSystem) {
      item.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
        alignToTop: true,
      });
    }
  },
};
</script>

<style scoped lang="scss">
.third-version{
  &.list--item {
    position: relative;

      &:after {
      content: '';
      position: absolute;
      top: 46px;
      left: 20px;
      bottom: 22px;
      width: 1px;
      background-color: #495057;
    }
  }

  .item--wrapper,
  .item--wrapper__content {
    display: flex;
    align-items: center;
    transition: 0.3s;
  }

  .item--wrapper {
    height: 46px;
    width: 100%;
    justify-content: space-between;
    padding: 0 15px 0 10px;
    cursor: pointer;
    background-color: white;
    border-top: 1px solid #eee;

    &.folder,
    &.table--item {
      position: relative;
      padding-left: 11%;
      margin-left: auto;

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        width: 5px;
        height: 1px;
        background-color: #495057;
        left: 20px;
      }
    }

    &.table--item {
      position: relative;
      padding-left: 15%;
      margin-left: auto;

      &:before {
        width: 10px;
      }
    }


    &.selected--item {
      background-color: #eee;
      font-weight: 600;
      color: #19407b;
    }

    .btn {
      padding: 10px;
    }
  }

  .item--wrapper__content {
  font-size: 13px;
  line-height: 22px;
  width: 80%;//todo (was 80% possibly because of chevron)
  gap: 10px;

  &:hover {
    font-weight: 500;
    text-shadow: 2px 2px 5px rgba(0, 0, 0, .2);
    color: #000;
  }

  a, span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #495057;
    text-decoration: none;
  }
  }

  .chevron {
    transition: 0.4s;

    &.opened {
      transform: rotate(90deg);
    }
  }
}


ul {
  & > li.fourth-version > button > .item--wrapper__content {
    text-transform: uppercase;
  }
}


.fourth-version{
  .item--wrapper,
  .item--wrapper__content {
  display: flex;
  align-items: center;
  }

  .item--wrapper {
  height: 46px;
  width: 100%;
  justify-content: space-between;
  padding: 0 15px 0 10px;
  cursor: pointer;
  background-color: white;

  &.folder,
  &.table--item {
    position: relative;
    padding-left: 11%;
    margin-left: auto;
  }

  &.table--item {
    position: relative;
    padding-left: 15%;
    margin-left: auto;

    &:before {
      width: 10px;
    }
  }

  &:hover {
    background-color: #eee;
    font-weight: 600;
    color: #19407b;
  }

  &.selected--item {
    background-color: #f1f1f1;
    font-weight: 600;
    color: #19407b;
  }

  .btn {
    padding: 10px;
  }
  }

  .item--wrapper__content {
  font-size: 13px;
  line-height: 22px;
  width: 80%;//todo (was 80% possibly because of chevron)
  gap: 10px;

  a, span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #495057;
    text-decoration: none;
  }
  }

  .chevron {
    transition: 0.4s;
    color: #ccc;

    &.opened {
      transform: rotate(90deg);
    }
  }
}

.item--wrapper__content-icon {
  width: 18px;
  height: 16px;
}

.content {
  height: 0;
  opacity: 0;

  &.show {
    opacity: 1;
    height: fit-content;
  }
}


.btn {
  &:focus {
    box-shadow: none;
  }
}

.edit-icon {
  width: 13px;
  height: 13px;
}
</style>
